import { Card } from "@material-tailwind/react";
import React from "react";

const AboutPage = () => {
  return (
    <div className="bg-gray-100 h-full p-8">
      <Card className="max-w-3xl mx-auto p-6 ">
        <h1 className="text-3xl text-black font-bold mb-6">About Us</h1>

        <p className="text-gray-700 mb-4 text-justify">
          Welcome to BlogSite! We are passionate about technology and dedicated
          to bringing you high-quality content that informs, inspires, and
          entertains.
        </p>

        <p className="text-gray-700 mb-4 text-justify">
          At BlogSite, we believe in the power of sharing knowledge and
          experiences. Whether you're a tech enthusiast exploring the latest
          gadgets or a business professional seeking insights into digital
          trends, or anyone in between, our goal is to provide valuable insights
          and engaging stories that resonate with you.
        </p>

        <p className="text-gray-700 mb-4 text-justify">
          Join us on this journey as we explore the fascinating world of
          technology. Feel free to browse through our articles, leave comments,
          and connect with us on social media. Your feedback is invaluable to
          us, and we're always looking for ways to improve and better serve our
          community.
        </p>

        <p className="text-gray-700 mb-4 text-justify">
          Thank you for being part of the BlogSite community. We're excited to
          have you with us, and we look forward to sharing more exciting content
          with you in the future.
        </p>

        <p className="text-gray-700">Happy reading!</p>
      </Card>
    </div>
  );
};

export default AboutPage;
